import { useState, useEffect } from "react";
import { useParams } from "react-router-dom";
import axios from "axios";
import css from "./index.module.css";

import SEO from "@components/seo";
import MainContent from "@components/content";
import CartProduct from "@components/cartProduct";

import * as Types from "../../types";
import { statusIcons, statusText } from "./order.info";
import { toast } from "sonner";
import useUserData from "@hooks/useUserData";

export default function Order() {
  const { id } = useParams();
  const [order, setOrder] = useState<Types.Order>();
  const { refreshCartData } = useUserData();
  
  useEffect(() => {
    axios
      .get(`${import.meta.env.VITE_API_URL}/user/order/${id}`, {
        headers: {
          "Content-Type": "application/json",
          Authorization: `Bearer ${localStorage.getItem("authToken")}`,
        },
      })
      .then((response) => {
        setOrder(response.data);
      })
      .catch((error) => {
        console.log(error);
      });
  }, [id]);
  
  const repeatOrder = () => {
    axios.post(`${import.meta.env.VITE_API_URL}/user/cart/copy`, { orderID: id }, {
      headers: {
        "Content-Type": "application/json",
        Authorization: `Bearer ${localStorage.getItem("authToken")}`,
      },
    })
    .then(_ => {
      toast.success("Корзина повторно создана");
      refreshCartData();
    })
    .catch((error) => {
      console.log(error);
      toast.error("Ошибка при повторном создании корзины");
    });
  }

  const totalPrice = Array.isArray(order?.products)
    ? order?.products.reduce((acc: number, item: Types.CartData) => acc + item.product.price * Number(item.count), 0)
  : 0;

  const timelineSteps = [1, 2, 3, 4];

  return (
    <MainContent header={`Заказ №${order?.shortID}`}>
      <SEO
        title="Заказ"
        description="Управление заказом"
        ogUrl="https://рыбныимир.рф/"
      />

      <div className={css.order}>
        <div className={css.col1}>
          <div className={css.summaryInfo}>
            <a>{new Date(order?.createdAt!).toLocaleString("ru-RU")}</a>
          </div>

          {order && order.status !== 5 && (
            <div className={css.timelineContainer}>
              <div className={css.timelineLine} />
              {timelineSteps.map((step) => (
                <div
                  key={step}
                  className={`${css.timelineStep} ${
                    order.status >= step ? css.active : ""
                  } ${order.status > step ? css.completed : ""}`}
                  style={step === 1 ? { alignItems: 'start' } : step === 4 ? { alignItems: 'end' } : {}}
                >
                  <div className={css.timelineIcon}>
                    {statusIcons[step]}
                  </div>
                  <div className={css.timelineText} style={step === 1 ? { paddingLeft: 5 } : {}}>
                    {statusText[step]}
                  </div>
                </div>
              ))}
            </div>
          )}

          <div className={css.orderInfo}>
            <div className={css.textOrderInfo}>
              <span>Организация</span>
              <b>{order?.organization ? order?.organization?.name : "Не указано"}</b>
            </div>

            <div className={css.textOrderInfo}>
              <span>Адрес</span>
              <b>{order?.address || "Не указано"}</b>
            </div>

            <div className={css.textOrderInfo}>
              <span>Стоимость</span>
              <b>{totalPrice.toLocaleString('ru-RU', { maximumFractionDigits: 2 })} ₽</b>
            </div>

            <button className={css.orderButton} onClick={repeatOrder}>Повторить заказ</button>
            <p className={css.orderButtonText}>Повторный заказ удалит текущую корзину</p>
          </div>
        </div>

        <div className={css.col2}>
          <b className={css.orderTitle}>Состав заказа</b>

          <div
            className={css.productList}
            style={
              Array.isArray(order?.products) && order.products.length > 1
                ? { marginBottom: 100 }
                : {}
            }
          >
            {order?.products.map((item: Types.CartData) => (
              <CartProduct
                id={item.id}
                prodID={item.product.id}
                quantity={0}
                image={item.product.images[0]}
                title={item.product.name}
                price={item.product.price}
                unit={item.product.unit}
                unitCart={item.unit}
                count={item.count}
                width={"100%"}
                buttons={false}
              />
            ))}
          </div>
        </div>
      </div>
    </MainContent>
  );
}
